import { getGaClientId } from '@/utils/ga4';

import analyticService from '@/services/analyticService';

const sendGAClientId = async userId => {
  try {
    const gaClientId = await getGaClientId();

    if (!gaClientId) return;

    const params = {
      ga_client_id: gaClientId,
      client_id: userId,
    };

    await analyticService.sendGAClientId(params);
  } catch (error) {
    console.error('Failed to send GA4 client_id:', error);
  }
};

export default {
  sendGAClientId,
};
